// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Root__wrapper___57N8w"};